export const contentForPopUp = [
  {
    itemText: 'Главная',
    itemImg: 'home',
    itemLink: '/home',
  },
  {
    itemText: 'Учебник',
    itemImg: 'book',
    itemLink: '/book',
  },
  {
    itemText: 'Спринт',
    itemImg: 'gameOne',
    itemLink: '/sprint_game',
  },
  {
    itemText: 'Аудиовызов',
    itemImg: 'gameTwo',
    itemLink: '/audio_call_game',
  },
  {
    itemText: 'Статистика',
    itemImg: 'statistic',
    itemLink: '/statistic',
  },
]
